export default __webpack_public_path__ + "static/media/main-logo.a3184373.png";